import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';
import clearFileProviderItems from './clearFileProviderItems';
import clearThenUpdateFileProviderItems from './clearThenUpdateFileProviderItems';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import loadMoreItemsForSelectedProvider from './loadMoreItemsForSelectedProvider';
import { logUsage } from 'owa-analytics';
import { action } from 'satcheljs/lib/legacy';
import getFileProviderItemsRequestCount, {
    incrementGetFileProviderItemsRequestCount,
} from './helpers/getFileProviderItemsRequestCount';

// TODO: bug 30332 make this an orcestrator and update other filepicker actions to use satchel 3.0
export default action('changeListViewItemsSorting')(async function changeListViewItemsSorting(
    sortType: AttachmentItemsSortColumn | null,
    viewState: FilePickerPanelViewState,
    customSort?: (
        items: FileProviderItemViewState[],
        sortAsc: boolean
    ) => FileProviderItemViewState[]
) {
    if (sortType === null) {
        return;
    }

    let sortOrder = AttachmentItemsSortOrder.Ascending;

    if (viewState.filePickerViewState.columnSorting.SortColumn === sortType) {
        sortOrder =
            viewState.filePickerViewState.columnSorting.SortOrder ===
            AttachmentItemsSortOrder.Descending
                ? AttachmentItemsSortOrder.Ascending
                : AttachmentItemsSortOrder.Descending;
    }

    viewState.filePickerViewState.columnSorting.SortColumn = sortType;
    viewState.filePickerViewState.columnSorting.SortOrder = sortOrder;

    logUsage('FPAttachmentsSort', [sortType, sortOrder]);
    incrementGetFileProviderItemsRequestCount();

    if (customSort) {
        const requestCount = getFileProviderItemsRequestCount();
        const sortedItems = customSort(
            viewState.filePickerViewState.fileProviderItems,
            sortOrder === AttachmentItemsSortOrder.Ascending
        );

        clearThenUpdateFileProviderItems(sortedItems, viewState, requestCount);
    } else {
        clearFileProviderItems(viewState.filePickerViewState);
        loadMoreItemsForSelectedProvider(viewState);
    }
});
